import { ref } from 'vue';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

const { getFaPointAPI, postUnbindFaPointAPI } = useAxiosAPI();

const modalStore = useModalStore();
const { closeModal } = modalStore;

const dataIsLoad = ref(false);
const isBind = ref(false);
const faPoint = ref(null);
const faBindingTime = ref(null);
const faUrl = ref(null);

function getFaPoint() {
  dataIsLoad.value = false;
  getFaPointAPI()
    .then((res) => {
      if (res.data.Code === 200) {
        if (res.data.Response !== null) {
          isBind.value = true;
          faPoint.value = res.data.Response.Point;
          faBindingTime.value = res.data.Response.BindingTime;
          faUrl.value = res.data.Response.FasneyDetailUrl;
        }
        dataIsLoad.value = true;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function cancelFaPoint() {
  postUnbindFaPointAPI()
    .then((res) => {
      if (res.data.Code === 200) {
        isBind.value = false;
        window.location.href = '/user/account';
      } else {
        closeModal();
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function useFaPoint() {
  return {
    dataIsLoad,
    isBind,
    faPoint,
    faBindingTime,
    faUrl,
    getFaPoint,
    cancelFaPoint,
  };
}

export default useFaPoint;
